import { render, staticRenderFns } from "./UpdateCommentForm.vue?vue&type=template&id=5d898354&scoped=true&"
import script from "./UpdateCommentForm.vue?vue&type=script&lang=js&"
export * from "./UpdateCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d898354",
  null
  
)

export default component.exports